import React from "react";

function SecretTerminal({ open, onClose }) {
  if (!open) return null;

  return (
    <aside className="secret-terminal" aria-label="Secret terminal">
      <button type="button" onClick={onClose} aria-label="Close secret terminal">x</button>
      <p>$ sudo access</p>
      <p>Privilege escalation denied.</p>
      <p>Nice try. Curiosity logged as a strength.</p>
      <p>Keep learning. Keep hardening. Stay sharp.</p>
    </aside>
  );
}

export default SecretTerminal;
